import { Component, OnInit, OnDestroy } from '@angular/core';
import { MainAnalyticsService } from '@profile/services/main_analytics.service';
import { AccountService as UserService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Profile } from '@df/interfaces';
import { declensionOfNumerals } from '@app/_utils/helpers';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';

@Component({
    selector: 'app-profile-results-lesson',
    templateUrl: './profile-results-lesson.component.html',
    styleUrls: ['./profile-results-lesson.component.scss']
})
export class ProfileResultsLessonComponent implements OnInit, OnDestroy {
    currentLessonData: any;
    profile: Profile;
    userPhoto: string;
    currencyStr = '';
    manyCurrency: string;
    toggleStarModal = false;
    starData = {
        type_achievement: {
            star: '',
            title: ''
        },
        explanation: '',
        exercises_results: []
    };
    routerEventSubscription: any;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private mainAnalyticsService: MainAnalyticsService,
        private userService: UserService,
        private handlerService: HandlerService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.profile = JSON.parse(localStorage.getItem('profile'));
        this.userPhoto = localStorage.getItem('userPhoto');
        this.routerEventSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const paternUrl = '/profile/results/lessons';
                const currentUrl = event.url.split('/');
                currentUrl.pop();
                const newCurrentUrl = currentUrl.join('/');
                if (paternUrl === newCurrentUrl) {
                    this.currentLessonData = null;
                    const lessonId = Number(event.url.replace(/[^0-9]/g, ''));
                    if (!lessonId) {
                        const currentLessonId = +localStorage.getItem('currentLessonId');
                        this.getStudentLessonData(currentLessonId);
                        return;
                    }
                    localStorage.setItem('currentLessonId', `${lessonId}`);
                    this.getStudentLessonData(lessonId);
                    this.createRequestCashes(lessonId);
                    this.getLessonCardsResults(lessonId);
                    return;
                }
            }
        });

        const lessonId = Number(this.activatedRoute.snapshot.params['lesson_id']);
        if (!lessonId) {
            const currentLessonId = +localStorage.getItem('currentLessonId');
            this.getStudentLessonData(currentLessonId);
            return;
        }
        localStorage.setItem('currentLessonId', `${lessonId}`);
        this.getStudentLessonData(lessonId);
        this.getLessonCardsResults(lessonId);
        this.createRequestCashes(lessonId);
    }

    public ngOnDestroy(): void {
        this.routerEventSubscription.unsubscribe();
        this.destroy$.next(true);
    }

    private createRequestCashes(currentLessonId: number): void {
        const lessonsId = JSON.parse(localStorage.getItem('LESSONS_IDs'));
        if (lessonsId.length) {
            const currentIndex = lessonsId.indexOf(currentLessonId);
            const prevLessonId = lessonsId[currentIndex - 1];
            const nextLessonId = lessonsId[currentIndex + 1];
            const lessons = [prevLessonId, nextLessonId];
            lessons.forEach(lessonId => {
                if (lessonId) {
                    this.mainAnalyticsService
                        .getStudentLessonData(lessonId)
                        .subscribe(resp => this.handlerService.checkErrors(resp));
                }
            });
        }
    }

    private getLessonCardsResults(lessonId): void {
        // выступает в качестве первого запроса для создания кеша
        this.mainAnalyticsService
            .getLessonCardsResults(lessonId, this.profile.user.id)
            .subscribe(resp => this.handlerService.checkErrors(resp));
    }

    private getStudentLessonData(lessonId: number = null): void {
        if (lessonId) {
            this.mainAnalyticsService.getStudentLessonData(lessonId).subscribe(resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.error) {
                    console.log(resp.data);
                    this.currentLessonData = resp.data;
                    this.setCurrency();
                }
            });
        }
    }

    private setCurrency(): void {
        this.userService.getLessonCurrency(this.currentLessonData.current_lesson.id).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                if (this.currentLessonData && this.currentLessonData.analytics) {
                    this.currencyStr = declensionOfNumerals(this.currentLessonData.analytics.count_earned, resp.data);
                }
                this.manyCurrency = declensionOfNumerals(5, resp.data);
                this.checkTypeAchievements();
            }
        });
    }

    private checkTypeAchievements(): void {
        if (this.currentLessonData && this.currentLessonData.stars.length) {
            this.currentLessonData.stars.forEach(star => {
                if (star.type_achievement.index_type === 3) {
                    star.type_achievement.title = star.type_achievement.title.replace('$', this.manyCurrency);
                }
            });
        }
    }

    openExercises(): void {
        this.router.navigate([`${this.router.url}/exercises`]).then();
    }

    starModal() {
        this.toggleStarModal = false;
    }

    showStarModal(star: any) {
        this.starData = {
            type_achievement: {
                star: star.type_achievement.star,
                title: star.type_achievement.title
            },
            explanation: star.explanation,
            exercises_results: star.exercises_results
        };
        this.toggleStarModal = true;
    }
}
